<template>
  <Select
    v-model="brand"
    @onSearch="onSearch"
    @onSelect="onSelect"
    @onClear="onClear"
    :options="getBrands"
    title="Marka Seçimi"
    placeholder="Marka Seçimi"
    v-readonly
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import brandService from '@/services/brand';
import Select from '../Select';

let brandNameRequestTimeout;
export default {
  name: 'BrandSelect',
  components: { Select },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      brands: [],
      brand: {},
    };
  },
  computed: {
    getBrands () {
      return this.brands.map(item => ({
        ...item,
        label: item.name,
      }));
    },
  },
  methods: {
    async getData (search) {
      const response = await brandService.getBrandByName({
        name: search,
        page: 0,
      });
      if (response.length) {
        this.brands = response;
      }
    },
    async onSearch (search) {
      clearTimeout(brandNameRequestTimeout);
      brandNameRequestTimeout = setTimeout(async () => {
        await this.getData(search);
      }, 500);
    },
    onSelect (option) {
      this.$emit('input', option);
    },
    onClear () {
      this.$emit('input', {});
    },
  },
  async created () {
    await this.getData('ab');
    this.brand = this.value;
  },
  watch: {
    value () {
      this.brand = this.value;
    },
  },
};
</script>
